import React, { useState, useEffect, useRef } from 'react';
import { lockedClose } from "../../../utils/lockedDialog";
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button,
  TextField, Grid, FormControl, InputLabel, Select, MenuItem,
  CircularProgress, Typography
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import {
   
  PackageDropdownafteradmission,
    MembeChangePackage,
    ChangePackageDropdownValue,
  } from "../../Apihelper/MemberApiHelpr";

  import {
    PackageadmissionDropdown,
    PackageAdmissionDropdownvalue,
  } from "../../Apihelper/AdmissionValueApi.js";
import AppToast from '../../../components/Toast/AppToast';
import { useTheme as useAppTheme } from '../../../contexts/ThemeContext';
import PayButton, { PaymentOverlay } from "../../../components/PayButton/PayButton";
import { limitAmount, cleanAmount } from "../../../utils/amounts";
const ChangePackage = ({ open, onClose, packageData,member_id,fetchData }) => {
  const { colors: appColors } = useAppTheme();
  const getCurrentDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Format: YYYY-MM-DD
};
const formatDateToYMD = (date) => {
  if (!date) return getCurrentDate(); // Return the current date if the input is empty or invalid

  const [day, month, year] = date.split('-'); // Split the d-m-y format
  const formattedDate = new Date(`${year}-${month}-${day}`); // Create a Date object
  return formattedDate.toISOString().split('T')[0]; // Format to 'yyyy-mm-dd' and return
};

const getMinStartDate = () => {
  console.log(packageData?.start_date);
  return packageData?.start_date
    ? formatDateToYMD(packageData.start_date)
    : getCurrentDate();
};
  const [formdueData, setFormdueData] = useState({
    member_id:'',
    package_id: '',
    total_payble_amount: '',
    payble_amount: '',
    offer: '',
    paying_amount: '',
    mode_of_payment: '',
    date_of_payment: getCurrentDate(),
    start_date: '', // Fallback to current date
   
   
    membershipvalue:"",
     membership:"",
  });
  const initializeState = async () => {
    const formattedStartDate = formatDateToYMD(packageData?.start_date); // Use the function to get the formatted date
    setFormdueData((prevData) => ({
      ...prevData,
      start_date: formattedStartDate, // Set the formatted date in the state
    }));
  };

  useEffect(() => {
    initializeState();
  }, []);

  // When modal opens: today for payment + start from package (DD/MM/YYYY shown via DatePicker)
  useEffect(() => {
    if (open) {
      setFormdueData((prev) => ({
        ...prev,
        date_of_payment: getCurrentDate(),
        start_date: packageData?.start_date
          ? formatDateToYMD(packageData.start_date)
          : getCurrentDate(),
      }));
    }
  }, [open, packageData?.start_date]);
  console.log(formdueData.start_date);
  const [renwalloading, setrenwalLoading] = useState(false);
  const submittingRef = useRef(false);
  const [confirmSaveOpen, setConfirmSaveOpen] = useState(false);
  const [Dropdowndata, setDropdowndata] = useState([]); // Default to 'success'
  const [openToast, setOpenToast] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success"); // Default to 'success'
  const [packageamount, setpackageamount] = useState(""); // Default to 'success'
  const [Dropdowndatamember, setDropdowndatamember] = useState([]);
  const [Dropdownadmissiondata, setDropdownadmissiondata] = useState([]); // Default to 'success'
  // const handlepayblevalueChangemember = async (e) => {
  //   const selectedPackageId = e.target.value;
  //   const selectedPackage = Dropdowndata.find(
  //     (row) => row.id === selectedPackageId
  //   );

  //   setFormdueData({
  //     ...formdueData,
  //     package_id: selectedPackageId,
  //     packagename: selectedPackage?.name || "",
  //   });

  //   try {
  //     const userData = localStorage.getItem("userdata");
  //     const userDataObj = JSON.parse(userData);
  //     const userToken = userDataObj.token;
  //     const userId = userDataObj.id;
  //     const res = await ChangePackageDropdownValue(
  //       userToken,
  //       userId,

  //       selectedPackageId,
  //       member_id,
  //     );

  //     if (res.code == "200") {
  //       // Ensure payble_amount and total_payble_amount are the same initially
  //       const packageAmount = res.data.package_amount;
  //       setFormdueData((prevState) => ({
  //         ...prevState,
  //         total_payble_amount: packageAmount,
  //         payble_amount: packageAmount, // Set both to the same value initially
  //       }));
  //     } else {
  //       console.error("API error:", res.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormdueData({
  //     ...formdueData,
  //     [name]: value
  //   });
  // };
  const handleInputChange = (e) => {
    const { name } = e.target;
    let value = e.target.value;

    setFormdueData((prevData) => {
      // Amounts: no minus sign; a discount can't pass the package price and the payment can't pass what is owed
      if (name === "offer") value = limitAmount(value, prevData.total_payble_amount);
      else if (name === "paying_amount") value = limitAmount(value, Number(prevData.total_payble_amount || 0) - Number(prevData.offer || 0));
      else if (name === "payble_amount" || name === "total_payble_amount") value = cleanAmount(value);
      let updatedData = { ...prevData, [name]: value };

      // Ensure 'payble_amount' starts as the same as 'total_payble_amount'
      if (!prevData.payble_amount) {
        updatedData.payble_amount = prevData.total_payble_amount;
      }

      // If 'offer' changes, update the payable amount based on the total payable amount and the offer
      if (name === "offer") {
        const updatedPayable = prevData.total_payble_amount - value;
        updatedData.paying_amount = updatedPayable >= 0 ? updatedPayable : 0;
      }

      if (name === "payble_amount") {
        updatedData.payble_amount = prevData.total_payble_amount; // Keep payble_amount same as total_payble_amount
      }
      return updatedData;
    });
  };

  const handleChangePaymentMode = (e) => {
    setFormdueData({
      ...formdueData,
      mode_of_payment: e.target.value
    });
  };

//   const handleSave = async () => {
//     setRenwalLoading(true);
//     try {
//       const response = await fetch('/api/renew-package', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json'
//         },
//         body: JSON.stringify(formdueData)
//       });
  
//       if (response.ok) {
//         const result = await response.json();
//         console.log('Package renewed successfully:', result);
//         fetchPackages(); // Refresh packages after successful save
//         onClose(); // Close the dialog
//       } else {
//         console.error('Failed to renew package:', response.statusText);
//       }
//     } catch (error) {
//       console.error('Error renewing package:', error);
//     } finally {
//       setRenwalLoading(false);
//     }
//   };


  const doSave = async () => {
    if (submittingRef.current) return;
    submittingRef.current = true;
    setConfirmSaveOpen(false);
    setrenwalLoading(true); // Show loader when form submission starts
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const response = await MembeChangePackage(
        userToken,
        userId,
        member_id,
        formdueData
      );

      if (response.code == "200") {
        setSnackbarMessage(response.message);
        setSnackbarSeverity("success");
        setOpenToast(true); // Show success Snackbar
        onClose(); // Close the modal
        fetchData();
        setFormdueData({
          member_id: member_id,
          package_id: "",
          total_payble_amount: "",
           payble_amount: "",
           offer: "",
           paying_amount: "",
           mode_of_payment: "",
           date_of_payment: getCurrentDate(),
           start_date: getCurrentDate(),
           end_date: "",
           membershipvalue:"",
           membership:""
        });
      } else {
        setSnackbarMessage(
          response.message || "Error occurred while renewing package."
        );
        setSnackbarSeverity("error");
        setOpenToast(true); // Show error Snackbar
      }
    } catch (error) {
      setSnackbarMessage("Failed to renew package: " + error.message);
      setSnackbarSeverity("error");
      setOpenToast(true); // Show error Snackbar
    } finally {
      setrenwalLoading(false);
      submittingRef.current = false;
    }
  };

  const handleSave = () => {
    setConfirmSaveOpen(true);
  };
  const fetchDropdowndatarenwal = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageDropdownafteradmission(userToken, userId);

      if (res.code == "200") {
        setDropdowndatamember(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  useEffect(() => {
    fetchDropdowndatarenwal();
    fetchDropdownAdmissiondata();
  }, []);
  const handleSnackbarOpen = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenToast(true);
  };
  const handleToastClose = () => {
    setOpenToast(false);
  };
  const fetchDropdownAdmissiondata = async () => {
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
      const res = await PackageadmissionDropdown(userToken, userId);

      if (res.code == "200") {
        setDropdownadmissiondata(res.data);
      } else {
        // handleSnackbarOpen(res.message, 'error');
        console.error(error);
      }
    } catch (error) {
      console.error(error);
      // Handle errors
    }
  };
  const [prevPackageAmount, setPrevPackageAmount] = useState(0);
  const handlepayblevalueChangemember = async (e) => {
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdowndatamember.find(
      (row) => row.id === selectedPackageId
    );

    setFormdueData((prevState) => {
      // The backend always computes the new package's end_date from the
      // member's CURRENT package start_date (getMinStartDate) + the new
      // package's duration — it does not use whatever is picked in the
      // "Start Date" field above. Mirror that here so this preview always
      // matches what actually gets saved.
      const computedEndDate = selectedPackage?.duration
        ? dayjs(getMinStartDate()).add(Number(selectedPackage.duration), "day").format("YYYY-MM-DD")
        : prevState.end_date;
      return {
        ...prevState,
        package_id: selectedPackageId,
        packagename: selectedPackage?.name || "",
        end_date: computedEndDate,
      };
    });
  
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
  
      const res = await ChangePackageDropdownValue(
        userToken,
        userId,
        selectedPackageId,
        member_id,
       
      );
  
      if (res.code == "200") {
        const packageAmount = res.data.amount_to_pay || 0;
  
        setFormdueData((prevState) => {
          // Subtract the previous amount and add the new one
          const total_payble_amount =
            (parseFloat(prevState.total_payble_amount) || 0) - prevPackageAmount + packageAmount;
  
          return {
            ...prevState,
            total_payble_amount,
            payble_amount: total_payble_amount, // Sync with total_payble_amount
          };
        });
  
        // Update the previous amount to the current selection's amount
        setPrevPackageAmount(packageAmount);
      } else {
        console.error("API error:", res.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const [prevAdmissionAmount, setPrevAdmissionAmount] = useState(0);
  const handlepayblevalueadmissionChange = async (e) => {
    const selectedPackageId = e.target.value;
    const selectedPackage = Dropdownadmissiondata.find(
      (row) => row.id === selectedPackageId
    );
  
    setFormdueData({
      ...formdueData,
      membership: selectedPackageId,
      membership_packagename: selectedPackage?.name || "",
    });
  
    try {
      const userData = localStorage.getItem("userdata");
      const userDataObj = JSON.parse(userData);
      const userToken = userDataObj.token;
      const userId = userDataObj.id;
  
      const res = await PackageAdmissionDropdownvalue(
        userToken,
        userId,
        selectedPackageId
      );
  
      if (res.code == "200") {
        const packageAmount = parseFloat(res.data) || 0;
  
        setFormdueData((prevState) => {
          // Subtract the previous admission amount and add the new one
          const total_payble_amount =
            (parseFloat(prevState.total_payble_amount) || 0) - prevAdmissionAmount + packageAmount;
  
          return {
            ...prevState,
            membershipvalue: packageAmount,
            total_payble_amount,
            payble_amount: total_payble_amount, // Sync with total_payble_amount
          };
        });
  
        // Update the previous admission amount to the current selection's amount
        setPrevAdmissionAmount(packageAmount);
      } else {
        console.error("Error response:", res.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  
  
  const handleClose = () => {
    onClose(); // closes the modal
    setFormdueData({
      member_id: member_id || '',
      package_id: "",
      total_payble_amount: "",
      payble_amount: "",
      offer: "",
      paying_amount: "",
      mode_of_payment: "",
      date_of_payment: getCurrentDate(),
      start_date: "",
      end_date: "",
      membershipvalue: "",
      membership: ""
    });
  };
  
  
  return (
    <>
    <Dialog
      open={open}
      onClose={lockedClose(onClose)}
      sx={{
        "& .MuiDialog-paper": {
          minWidth: "800px",
        },
      }}
    >
      <DialogTitle
        sx={{ 
          bgcolor: appColors.evergreen, // Navy blue background
          color: 'white',
          padding: '16px 24px',
          fontSize: '1.25rem',
          fontWeight: 600
        }}
      >
        Change Package
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={3}>
          <Grid size={{ xs: 6}} sx={{ marginTop: "20px" }}>
            <FormControl fullWidth>
              <InputLabel id="package-label">Package</InputLabel>
              <Select
                  labelId="package-label"
                  id="package"
                  label="Package"
                  value={formdueData.package_id}
                  onChange={handlepayblevalueChangemember}
                  fullWidth
                >
                  {Dropdowndatamember.map((row) => (
                    <MenuItem key={row.id} value={row.id}>
                      {row.name}
                    </MenuItem>
                  ))}
                </Select>
            </FormControl>
          </Grid>
          {packageData && packageData.admission_expired && (
  <>
    <Grid size={{ xs: 6}} sx={{ marginTop: "20px" }}>
      <FormControl fullWidth>
        <InputLabel id="membership-label">Membership</InputLabel>
        <Select
          labelId="membership-label"
          id="membership"
          label="Membership"
          value={formdueData.membership}
          onChange={handlepayblevalueadmissionChange}
          placeholder="Choose Membership"
          fullWidth
        >
          {Dropdownadmissiondata.map((row) => (
            <MenuItem key={row.id} value={row.id}>
              {row.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    <Grid size={{ xs: 6}} sx={{ marginTop: "20px" }}>
      <TextField
      fullWidth
       labelId="membership-Value"
          id="membership-value"
        label="Membership Value"
        inputProps={{ readOnly: true }}
        InputLabelProps={{ shrink: true }}
       
        value={formdueData.membershipvalue}
        onChange={(e) =>
          setFormdueData({
            ...formdueData,
            membershipvalue: e.target.value,
          })
        }
      />
    </Grid>
  </>
)}


          <Grid size={{ xs: 6}} sx={{ marginTop: "20px" }}>
            <TextField
              label="Total Payable Amount"
              fullWidth
              name="total_payble_amount"
              value={formdueData.total_payble_amount}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid size={{ xs: 6}}>
            <TextField
              type="number"
              label="Payable Amount"
              fullWidth
              name="payble_amount"
              value={formdueData.payble_amount}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid size={{ xs: 6}}>
            <TextField
              label="Offer"
              fullWidth
              name="offer"
              value={formdueData.offer}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid size={{ xs: 6}}>
            <TextField
              type="number"
              label="Paying Amount"
              fullWidth
              name="paying_amount"
              value={formdueData.paying_amount}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid size={{ xs: 6}}>
            <FormControl sx={{ minWidth: 120 }} fullWidth>
              <InputLabel id="mode-of-payment-label">
                Mode of Payment
              </InputLabel>
              <Select
                fullWidth
                sx={{ minWidth: 120, height: "50px" }}
                labelId="mode-of-payment-label"
                id="mode-of-payment"
                label="Mode of Payment"
                value={formdueData.mode_of_payment}
                name="mode_of_payment"
                onChange={handleChangePaymentMode}
              >
                <MenuItem value="paytm">Paytm</MenuItem>
                <MenuItem value="googlepay">Google Pay</MenuItem>
                <MenuItem value="phonepe">PhonePe</MenuItem>
                <MenuItem value="cash">Cash</MenuItem>
                <MenuItem value="card"> Card</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid size={{ xs: 6}}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="en-gb"
            >
              <DatePicker
                label="Date of Payment"
                format="DD/MM/YYYY"
                value={
                  formdueData.date_of_payment
                    ? dayjs(formdueData.date_of_payment)
                    : dayjs()
                }
                onChange={(d) =>
                  d &&
                  setFormdueData((prev) => ({
                    ...prev,
                    date_of_payment: d.format("YYYY-MM-DD"),
                  }))
                }
                slotProps={{
                  textField: { fullWidth: true },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid size={{ xs: 6}}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="en-gb"
            >
              <DatePicker
                label="Start Date"
                format="DD/MM/YYYY"
                minDate={dayjs(getMinStartDate())}
                value={
                  formdueData.start_date
                    ? dayjs(formdueData.start_date)
                    : dayjs(getMinStartDate())
                }
                onChange={(d) =>
                  d &&
                  setFormdueData((prev) => ({
                    ...prev,
                    start_date: d.format("YYYY-MM-DD"),
                  }))
                }
                slotProps={{
                  textField: { fullWidth: true },
                }}
              />
            </LocalizationProvider>
          </Grid>

          <Grid size={{ xs: 6}} sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography sx={{ fontSize: 14, fontWeight: 600, color: formdueData.end_date ? appColors.evergreen : 'text.secondary' }}>
              {formdueData.end_date
                ? `Expire: ${dayjs(formdueData.end_date).format("DD/MM/YYYY")}`
                : 'Select a package to see expiry'}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={onClose}
          startIcon={<CancelIcon />}
          sx={{
            color: appColors.evergreen,
            borderColor: appColors.evergreen,
            '&:hover': {
              borderColor: appColors.pine,
              bgcolor: 'rgba(31, 122, 84, 0.04)'
            },
            textTransform: 'none',
            fontWeight: 600
          }}
        >
          Cancel
        </Button>
        <PayButton
          variant="contained"
          onClick={handleSave}
          startIcon={<CheckCircleIcon />}
          loading={renwalloading}
          sx={{
            bgcolor: appColors.evergreen,
            '&:hover': { bgcolor: appColors.pine },
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: '0 4px 6px rgba(31, 122, 84, 0.12)',
            '&:hover': {
              bgcolor: appColors.pine,
              boxShadow: '0 6px 8px rgba(31, 122, 84, 0.2)',
            }
          }}
        >
          {renwalloading ? <CircularProgress size={24} /> : 'Payment'}
        </PayButton>
      </DialogActions>
    </Dialog>

    {/* Are you sure? - Change Package */}
    <Dialog open={confirmSaveOpen} onClose={lockedClose(() => setConfirmSaveOpen(false))} maxWidth="xs" fullWidth>
      <DialogTitle>Confirm</DialogTitle>
      <DialogContent>
        <DialogContentText>Are you sure you want to change the package?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setConfirmSaveOpen(false)} color="primary" variant="outlined">Cancel</Button>
        <PayButton onClick={doSave} color="primary" variant="contained" startIcon={<CheckCircleIcon />} loading={renwalloading}>Yes, change package</PayButton>
      </DialogActions>
    </Dialog>

<PaymentOverlay open={renwalloading} text="Changing package" />
<AppToast open={openToast} message={snackbarMessage} severity={snackbarSeverity} onClose={handleToastClose} />
</>
  );
};

export default ChangePackage;
